import {
  FormControl,
  Select
} from '@chakra-ui/react'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormLabel, InputGroup } from '@/components'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useSelections } from '@/hooks'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'

export const AdditionalPropertyInfoKb = () => {
  const { insuranceParams } = useInsuranceParams()

  const { data: dataVztah } = useSelections(SelectionType.RelationInsuredToPolicyHolder)

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { register, watch, formState: { errors }, getFieldState, setValue, getValues } = useFormContext<WizardPropertyAdditionalData>()

  const setRelation = watch('property.additionalDataKb.relationInsuredToPolicyHolder') 

  return (
    <>
      <FormRow>
        <FormControl isRequired isInvalid={!!errors.property?.additionalDataKb?.relationInsuredToPolicyHolder}>
          <FormLabel>Vztah pojistníka k pojištěnému</FormLabel>
    
          {(dataVztah?.data.length ?? 0) > 0 &&
            <Select
              {...register('property.additionalDataKb.relationInsuredToPolicyHolder')}
              isDisabled={isContracted}
              defaultValue={getValues('property.additionalDataKb.relationInsuredToPolicyHolder') ?? ''}              
            >
              <option value=''>Vyberte</option>
              {dataVztah?.data.map((item) => (
                <option value={item.id?.toString()} key={item.id}>{item.description}</option>
              ))}
            </Select>
          }
        </FormControl>

        {setRelation == Selection.RelationInsurerToPolicyHolderOther && (                
          <FormControl isRequired isInvalid={!!errors.property?.additionalDataKb?.relationInsuredToPhOtherText}>
            <FormLabel>Specifikace vztahu</FormLabel>
            <InputGroup
              isDisabled={isContracted}
              id="relationInsuredToPhText"
              htmlSize={30}
              autoComplete="off"
              errors={errors.property?.additionalDataKb?.relationInsuredToPhOtherText}
              {...register('property.additionalDataKb.relationInsuredToPhOtherText')}
            />
          </FormControl>
        )}
      </FormRow>
    </>
  )
}
